export enum ReportPeriodEnum {
  USER_DEFINED = 'USER_DEFINED',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  YEAR = 'YEAR',
}
